module.exports = __webpack_public_path__ + "static/media/click-game.f8060ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/click-game.png
// module id = 89
// module chunks = 0